import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "payments";

export const saveAccountPaymentAsync = async (id, data) => {
  const payment = { ...data };
  payment["accounting_invoice_id"] = data.accounting_invoice_id.value;
  payment["payment_type"] = data.payment_type.value;

  return await http.post(`${apiEndpoint}/accounts/${id}`, payment);
};

export const sendReceiptAsync = async (id) => {
  return await http.post(`${apiEndpoint}/mail/${id}`);
};

export const getAccountPaymentsAsync = async (id, params) => {
  const {
    types,
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/accounts/${id}?q=${query}&types=${types}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getPaymentTypes = () => {
  return [
    { value: 4, label: "Gcash" },
    { value: 5, label: "Bank Transfer" },
    { value: 1, label: "Cash" },
    { value: 2, label: "Credit Card" },
    { value: 3, label: "Cheque" },
  ];
};

export const paymentService = {
  saveAccountPaymentAsync,
  sendReceiptAsync,
  getAccountPaymentsAsync,
  getPaymentTypes,
};

export default paymentService;
